export const REDIRECT_URI_AFTER_SESSION_ERROR_SEARCH_PARAM_KEY = 'redirect-uri-after-session-error';
export const REDIRECT_URI_AFTER_LOGIN_SEARCH_PARAM_KEY = 'redirect-uri-after-login';
